var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnnotationGroundTruth = function SvgAnnotationGroundTruth(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38887 4.44399C9.58125 3.852 10.4188 3.852 10.6111 4.44399L11.5871 7.44738C11.6731 7.71212 11.9199 7.89136 12.1982 7.89137L15.3562 7.89149C15.9787 7.89152 16.2375 8.68804 15.7339 9.05393L13.1791 10.9102C12.9539 11.0739 12.8597 11.3639 12.9457 11.6286L13.9214 14.6321C14.1138 15.2241 13.4362 15.7164 12.9326 15.3505L10.3777 13.4944C10.1525 13.3308 9.84753 13.3308 9.62232 13.4944L7.06738 15.3505C6.56378 15.7164 5.88623 15.2241 6.07855 14.6321L7.05431 11.6286C7.14032 11.3639 7.04609 11.0739 6.82089 10.9102L4.2661 9.05393C3.76253 8.68803 4.02133 7.89152 4.64379 7.89149L7.80178 7.89137C8.08015 7.89136 8.32686 7.71212 8.41289 7.44738L9.38887 4.44399Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnnotationGroundTruth);
export { ForwardRef as ReactComponent };